import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { clearSelectedVisitPartAction, updateVisitPartAction } from '../../../../redux/actions/visitPartsActions';
import { createPart } from '../../../../redux/api/partsApi';
import { convertToVisitPartRequest } from '../../../../utils/requestMapper';
import Button from '../../../shared/buttons/Button';
import Modal from '../../../shared/modal/Modal';
import VisitPartForm from '../forms/VisitPartForm';

const UpdateVisitPartModal = ({ readOnly, onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { vin, id } = useSelector((state) => state.visit.visit);
  const visitPart = useSelector((state) => state.visitParts?.visitPart);

  const onSubmit = async (data) => {
    setLoading(true);

    if (data.partName) {
      const { error, data: newPart } = await createPart({ name: data.partName, price: data.partPrice });
      if (error) {
        toast.error(error?.message || 'Не вдалося створити деталь');
        setLoading(false);
        return;
      }
      data.part = { id: newPart.id };
    }

    if (!data.part?.id) {
      toast.error('Оберіть деталь або створіть нову');
      setLoading(false);
      return;
    }

    const part = convertToVisitPartRequest(data);
    await dispatch(updateVisitPartAction(vin, id, visitPart.id, part));
    await dispatch(clearSelectedVisitPartAction());
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Змінити деталь'}
      loading={loading}
      onClose={onModalClose}
      body={<VisitPartForm readOnly={readOnly} onSubmit={onSubmit} loading={loading} part={visitPart} />}
      actionButton={
        !readOnly && (
          <Button
            type={'submit'}
            disabled={loading}
            variant={'primary'}
            formId={'visitPart-form'}
            children={'Змінити'}
          />
        )
      }
    />
  );
};

export default UpdateVisitPartModal;
